import { gql } from "@apollo/client";

export const CREATE_CLASSIFICATION = gql`
  mutation ($metrics: String!, $action: action!, $organizationId: String!) {
    createUserClassification(input: {
      metrics: $metrics,
      action: $action,
      organization: $organizationId
    }) {
      metrics
      action
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport(
    $organizationId: String!
    $reportName: String!
    $snapshot: String!
  ) {
    createReport(input: {
      name: $reportName,
      snapshot: $snapshot,
      organization: $organizationId,
    }) {
      uid
      errors {
        messages
        field
      }
    }
  }
`;

export const CREATE_REPORT_CLEARING_CORRIDOR = gql`
  mutation CreateReportClearingCorridor(
    $report: String!
    $clearingcorridor: String!
    $organizationId: String!
  ) {
    createReportClearingCorridor(input: {
      report: $report
      clearingcorridor: $clearingcorridor
      organization: $organizationId
    }) {
      uid
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_SAR_TASKING_ORDER = gql`
  mutation CreateSarTaskingOrder(
    $geometry: String!
    $name: String!
    $organizationId: String!
  ) {
    createSarTaskingOrder(input: {
      geometry: $geometry
      name: $name
      organization: $organizationId
    }) {
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_SNAPSHOT_NAME = gql`
  mutation UpdateSnapshotName(
    $uid: String!
    $displayName: String!
  ) {
    updateSnapshot(input: {
      uid: $uid
      displayName: $displayName
    }) {
      id
      displayName
      errors {
        field
        messages
      }
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation LogoutUser {
    logoutUser {
      ok
    }
  }
`;
